import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { merge as observableMerge } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { ApiService } from './services/api.service';
import { EventsService } from './services/events.service';
import { HostMessageService } from './services/host-message.service';
import { ModalService } from './services/modal.service';
import { ProfileService } from './services/profile.service';
import { SettingsService } from './services/settings.service';
import { ModalComponent } from './shared/components/modal/modal.component';
import {
  isAidParams,
  isClubCityParams,
  isVkParams,
  isWParams,
  QueryStringParams,
} from './shared/models/parameters.model';
import { IToken } from './shared/models/profile.model';
import { WidgetType } from './shared/models/widget.model';
import { blueTheme } from './themes/blue-theme';
import { greenTheme } from './themes/green-theme';
import { purpleTheme } from './themes/purple-theme';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)',
  },
})
export class AppComponent implements OnInit {
  public bodyElement: HTMLBodyElement;
  public clubIdParams: string;
  public userId: string;
  public themeParams: string;
  public themes = {
    purple: purpleTheme,
    green: greenTheme,
    blue: blueTheme,
  };
  @ViewChild('container') elementView: ElementRef;
  @ViewChild(ModalComponent) modal: ModalComponent;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private modalService: ModalService,
    private settingsService: SettingsService,
    private hostMessageService: HostMessageService,
    private eventsService: EventsService,
    private hostElementRef: ElementRef,
    private profileService: ProfileService,
  ) {}

  userInfo;
  userProfile;

  onResize(event) {
    this.hostMessageService.postMessage({
      type: 'widget-set-height',
      height: this.getScheduleHeight(),
    });
    this.returnWidthContainer();
  }

  public returnWidthContainer() {
    const wgContainer = <HTMLElement>(
      document.getElementsByClassName('widget-container')[0]
    );
    wgContainer.style.width = 'auto';
  }

  private setStyle(style: string) {
    if (style) {
      const styleContent = document.createTextNode(style.replace(/\n/g, ''));
      const existing: HTMLStyleElement = document.querySelector(
        '.widget-style-injected',
      );
      if (existing) {
        existing.replaceChild(styleContent, existing.childNodes[0]);
      } else {
        const styleTag = document.createElement('style');
        styleTag.appendChild(styleContent);
        styleTag.classList.add('widget-style-injected');
        document.querySelector('html')?.appendChild(styleTag);
      }
    }
  }

  private injectScrollbarStyle() {
    // document.body.style.overflow = 'scroll';
    //const style = `.modal-visible{padding-right:${window.innerWidth - document.body.clientWidth}px}`;
    //document.body.style.overflow = null;
    //const styleContent = document.createTextNode(style);
    //const styleTag = document.createElement('style');
    // styleTag.appendChild(styleContent);
    // styleTag.classList.add('scrollbar-width-style-injected');
    //document.querySelector('html').appendChild(styleTag);
  }

  private getWidgetHeight() {
    const elHeight =
      this.elementView && this.elementView.nativeElement
        ? Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight,
            document.body.offsetHeight,
            document.documentElement.offsetHeight,
            document.body.clientHeight,
            document.documentElement.clientHeight,
          )
        : 0;

    const modalHeight =
      this.modal.elementView && this.modal.elementView.nativeElement
        ? this.modal.elementView.nativeElement.scrollHeight
        : 0;
    return Math.max(elHeight, modalHeight);
  }

  public getScheduleHeight() {
    // Если вдруг, открыт длинный дропбокс (фильтр расписания)
    let heightDrop = 0;
    const docDrops = document.getElementsByClassName('dropdown-options');

    for (let i = 0; i < docDrops.length; i++) {
      const drop = <HTMLElement>docDrops[i];
      if (drop.offsetHeight > heightDrop) {
        heightDrop = drop.offsetHeight;
      }
    }

    const body = document.querySelector('body');
    const settings = body?.getBoundingClientRect();
    return settings.height > heightDrop ? settings?.height : heightDrop + 110;
  }

  public ngOnInit() {
    localStorage.removeItem('currentDay');
    this.checkToken();

    this.bodyElement = this.hostElementRef.nativeElement as HTMLBodyElement;
    //this.injectScrollbarStyle();
    observableMerge(
      this.eventsService.resizeObserver.pipe(debounceTime(30)),
      this.eventsService.event('height'),
    )
      .pipe(
        map(() => this.getWidgetHeight()),
        distinctUntilChanged(),
      )
      .subscribe((height) =>
        this.hostMessageService.postMessage({
          type: 'widget-set-height',
          height,
        }),
      );
    this.settingsService.settings.subscribe((settings) => {
      if (settings) {
        if (settings.settings.style) {
          this.setStyle(settings.settings.style);
        }

        this.route.queryParams.subscribe((params) => {
          this.clubIdParams = params['clubId'];
          this.themeParams = params['theme'];
          this.userId = params['userId'];

          if (typeof this.clubIdParams !== 'undefined') {
            if (this.themeParams == 'theme-purple') {
              this.setStyle(this.themes.purple);
              console.log('themeParams', this.themeParams);
            } else if (this.themeParams == 'theme-green') {
              this.setStyle(this.themes.green);
              console.log('themeParams', this.themeParams);
            } else if (this.themeParams == 'theme-blue') {
              this.setStyle(this.themes.blue);
              console.log('themeParams', this.themeParams);
            }
            // this.router.navigate([`/${settings.widgetType}`], {
            //   queryParams: {
            //     w: settings.widgetId,
            //     clubId: this.clubIdParams,
            //     theme: this.themeParams,
            //     userId: this.userId
            //   }
            // });
          } else {
            const filterName = params['filterName'];
            const filterId = params['filterId'];
            const isInstagramLoader = params['isInstagramLoader'];
            const planId = params['planId'];

            if (
              settings.widgetId &&
              settings.widgetType &&
              (!filterName || !filterId)
            ) {
              if (location.href.indexOf(location.host + `/?`) > 0) {
                const url =
                  `/${settings.widgetType}?w=${settings.widgetId}` +
                  (isInstagramLoader ? '&isInstagramLoader=true' : '') +
                  (planId ? `&planId=${planId}` : '');
                this.router.navigateByUrl(url);
              }
            }
          }
        });
      }
    });

    this.route.queryParams.subscribe((params: QueryStringParams) => {
      if (params && params['vk_bind_widget']) {
        return;
      }
      if (params) {
        if (isWParams(params) || isVkParams(params)) {
          this.settingsService.loadRemoteSettings(params);
        } else if (isClubCityParams(params)) {
          let path: string = null;
          try {
            path = this.route.firstChild.routeConfig.path;
          } catch {}
          if (path) {
            this.settingsService.loadDefaultSettings(
              params,
              path as WidgetType,
            );
          }
        } else if (isAidParams(params)) {
          const vkAppIds = environment.vkAppIds;
          const targetWidgetType =
            Object.keys(vkAppIds).find((x) => vkAppIds[x] === params.api_id) ||
            WidgetType.Schedule;
          this.router.navigate([`/search`], {
            queryParams: { returnTo: targetWidgetType },
          });
        }
      }
    });

    // this.profileService.userInfo.subscribe(userInfo => {
    //   this.userInfo = userInfo;
    //   // this.cartService.update();
    //   // this.sendHeartBeat();
    // });

    // this.profileService.userProfile.subscribe(userProfile => {
    //   const previousProfile = this.userProfile;
    //   this.userProfile = userProfile;

    //   if (userProfile) {
    //     // if (!userProfile.isAgreementAccepted) {
    //     //   this.showOffer(userProfile);
    //     // }
    //     if (!previousProfile && this.userProfile.isFirstEntry) {
    //       // this.initUserCity();
    //     }
    //   }
    // });
  }

  private checkToken() {
    this.route.queryParams.subscribe((queryParams) => {
      let token: IToken = {
        accessToken: queryParams['token'],
        expiresAt: null,
        isNewRegistration: null,
        issuedAt: null,
        refreshToken: null,
      };

      if (token && token.accessToken) {
        this.profileService.writeToken(token);
        this.profileService.isToken.next(true);
      }

      if (queryParams['theme']) {
        this.profileService.isApp.next(true);
      }

      if (queryParams['isMiniApp']) {
        if (queryParams['isMiniApp'] == 'true')
          this.profileService.isMiniApp.next(
            queryParams['isMiniApp'] as boolean,
          );
      }
    });
  }
}
